import User from './User'
import Notification from './Notification'
export default class Document {
  constructor(objIn = {}) {
    const defaults = {
      //ID is required
      Id: 0,
      //TrackedBillID is required
      TrackedBillID: 0,
      //FileName is required
      FileName: '',
      MimeType: null,
      //CreatedByID is required
      CreatedByID: 0,
      //CreatedDate is required
      CreatedDate: new Date().toISOString().split('T')[0],
      //IsDeleted is required
      IsDeleted: false,
      DocumentFile: { File: null },
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.Id = obj.Id
    this.TrackedBillID = obj.TrackedBillID
    this.FileName = obj.FileName
    this.MimeType = obj.MimeType
    this.CreatedByID = obj.CreatedByID
    this.CreatedDate = obj.CreatedDate
    this.IsDeleted = obj.IsDeleted
    this.DocumentFile = obj.DocumentFile
    this.CreatedBy = new User(obj.CreatedBy || {})
    this.Notifications = []
    if (obj.Notifications) {
      obj.Notifications.forEach((item) => {
        this.Notifications.push(new Notification(item))
      })
    }
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.CreatedBy = null
    obj.Notifications = []
    if (this.Notifications) {
      this.Notifications.forEach((item) => {
        obj.Notifications.push(item.removeRelated())
      })
    }
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.CreatedBy = null
    obj.Notifications = null
    return obj
  }
}
